<template>
  <section class="section journey-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 d-flex align-items-center">
          <div class="start-your-journey aos" data-aos="fade-up">
            <h2>Về chúng tôi</h2>
            <h2><span class="active-sport">EZBadminton</span> - Hệ thống quản lý giải đấu cầu lông chuyên nghiệp</h2>
            <p>EZBadminton là hệ thống quản lý giải đấu chuyên nghiệp, được thiết kế để mang đến trải nghiệm tổ chức và
              tham gia thi đấu tiện lợi, minh bạch và hiệu quả.</p>
            <p>Chúng tôi cung cấp các công cụ hiện đại để quản lý lịch thi đấu, theo dõi kết quả và xếp hạng vận động
              viên,
              giúp ban tổ chức dễ dàng vận hành giải đấu và người chơi cập nhật thông tin nhanh chóng.</p>
            <span class="stay-approach">Luôn Dẫn Đầu Cùng EZBadminton Với Giải Pháp Quản Lý Giải Đấu Hiện Đại:</span>
            <div class="journey-list">
              <ul>
                <li><i class="fa-solid fa-circle-check"></i>Hệ Thống Quản Lý Chuyên Nghiệp</li>
                <li><i class="fa-solid fa-circle-check"></i>Công Nghệ Hiện Đại</li>
                <li><i class="fa-solid fa-circle-check"></i>Hỗ Trợ Đăng Ký Trực Tuyến</li>
              </ul>
              <ul>
                <li><i class="fa-solid fa-circle-check"></i>Bảng Xếp Hạng & Kết Quả Trực Tiếp</li>
                <li><i class="fa-solid fa-circle-check"></i>Tùy Chỉnh Giải Đấu</li>
                <li><i class="fa-solid fa-circle-check"></i>Giao Diện Thân Thiện.</li>
              </ul>
            </div>
            <div class="convenient-btns">
              <router-link class="btn btn-primary d-inline-flex align-items-center" to="/lien-he">
                <span><i class="feather-user-plus me-2"></i></span>Liên hệ
              </router-link>
              <router-link class="btn btn-secondary d-inline-flex align-items-center" to="/ve-chung-toi">
                <span><i class="feather-align-justify me-2"></i></span>Xem thêm
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="journey-img">
            <img alt="User" class="img-fluid" src="@/assets/img/image_badminton.png">
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Journey -->
</template>

<script setup>

</script>